import React, { memo } from 'react';
import { useTranslation } from '@pascal/pascal-core';
import { Chart } from '../chart';
import { BettingPart } from '../../../containers/common/bettingParts';

export const GameContent = memo(() => {
  const t = useTranslation();
  return (
    <div className='crash-structure'>
      <Chart t={t} />
      <BettingPart t={t} />
    </div>
  );
});
